import { useEffect, useState, useMemo } from "react";
import { EditorBodegaDocumentos } from "../../bodegaDocumentos/EditorBodegaDocumentos";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { PrintJson } from "../../../theme/Component/PrintJson";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _BudgetCDPreductionFactory } from "../../../../core/services/dataBean/EntityCatalogVdos";


interface Props {
    data: any;
    onChange: Function;
}
export const BudgetList = ({ data, onChange }: Props) => {

    const [list, setList] = useState<any>([]);
    const [typeTraslate, setTypeTraslate] = useState<number>(0);


    const tipos = [
        { id: 0, name: "Reserva Presupuestal" },
        { id: 1, name: "Cuentas por Pagar" }
    ]

    useEffect(() => {
        onChange({ ...data, "List": list });
    }, [list])
    useEffect(() => {
        onChange({ ...data, "TypeTraslate": typeTraslate });
    }, [typeTraslate])

    const addDocument = (e) => {
        setList([...list, e]);
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: false },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Consecutivo Externo', property: 'ExternalReference', visible: true },
        { title: 'Fecha Creación', property: 'Since', visible: true },
        { title: 'Estado del Documento', property: 'DocumentStateName', visible: true },
    ]

    const wrappedList = useMemo(() => {
        return list.map((item) => ({ DataBeanProperties: item }));
    }, [list]);

    return (
        <div className="row">
            <div className="col-md-6">
                <label >Tipo Traslado</label>
                <select className="form-select" disabled={list.length > 0} value={typeTraslate} onChange={(e) => { setTypeTraslate(parseInt(e.target.value)) }}>
                    {tipos.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                    ))}
                </select>
            </div>
            <div className="col-md-6">
                <EditorBodegaDocumentos year={data.Year} nemonic={typeTraslate == 0 ? "RP" : "OB"} onChange={addDocument} />
            </div>
            <div className="col-md-12">
                <BasicTable body={wrappedList} head={head} rowSet={(e) => { }} />
                {/* <PrintJson json={list} /> */}
            </div>
        </div>
    )
}